/* ==========================================================================
   Solid Viibe — product page behaviour
   Variant switching, gallery thumbnails, one-time vs subscribe toggle.
   Vanilla custom elements, no framework.
   ========================================================================== */
(function () {
  'use strict';

  var money = (window.SolidViibe && window.SolidViibe.formatMoney) || function (c) {
    return '$' + (c / 100).toFixed(2);
  };

  /* --- Variant picker --------------------------------------------------- */
  function initProduct(root) {
    if (!root || root.dataset.productReady === 'true') return;
    var form = root.querySelector('[data-product-form]');
    var json = root.querySelector('[data-variant-json]');
    if (!form || !json) return;

    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    root.dataset.productReady = 'true';

    /* Per-variant flavour token (see sections/main-product.liquid). Only a
       product that genuinely has a Flavour option produces more than one
       distinct value here — a Size-only product maps every variant id to the
       same token, so the recolour step below is a correct no-op for it. */
    var flavourMap = {};
    var flavourJson = root.querySelector('[data-flavour-map]');
    if (flavourJson) {
      try { flavourMap = JSON.parse(flavourJson.textContent); } catch (err2) { flavourMap = {}; }
    }

    function applyFlavour(variant) {
      var next = flavourMap[String(variant.id)];
      if (!next || next === root.dataset.flavour) return;
      root.dataset.flavour = next;
    }

    function applyGalleryImage(variant) {
      var image = variant.featured_image;
      if (!image || !image.src) return;
      var main = root.querySelector('#gallery-main');
      if (!main) return;
      var src = image.src;
      if (src.indexOf('//') === 0) src = window.location.protocol + src;
      if (main.src === src) return;
      main.src = src;
      main.removeAttribute('srcset');
      main.alt = variant.title || main.alt;
      root.querySelectorAll('.svp-thumb').forEach(function (button) {
        button.setAttribute('aria-current', String(button.dataset.src === src));
      });
    }

    function selectedOptions() {
      var indices = [];
      form.querySelectorAll('[data-option-index]:checked').forEach(function (input) {
        indices[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return indices;
    }

    function update() {
      var chosen = selectedOptions();
      var variant = variants.find(function (candidate) {
        return candidate.options.every(function (option, index) { return option === chosen[index]; });
      });
      var select = form.querySelector('[data-variant-select]');
      var submit = form.querySelector('[data-product-submit]');
      var priceEl = root.querySelector('[data-product-price]');
      var compareEl = root.querySelector('[data-product-compare]');

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (select) select.value = String(variant.id);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart · ' + money(variant.price) : 'Sold out';
      }
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        if (!compareEl.hidden) compareEl.textContent = money(variant.compare_at_price);
      }
      root.querySelectorAll('[data-afterpay-instalment]').forEach(function (el) {
        el.textContent = money(variant.price / 4);
      });
      /* The "One time" row in Delivery quotes the same figure as the main
         price, so it has to move with it. The subscription rows carry a
         percentage rather than an amount and need nothing here. */
      root.querySelectorAll('[data-plan-price]').forEach(function (el) {
        el.textContent = money(variant.price);
      });
      applyFlavour(variant);
      applyGalleryImage(variant);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-index]')) update();
    });
  }

  document.querySelectorAll('[data-product-root]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (event) {
    initProduct(event.target.querySelector('[data-product-root]'));
  });

  /* --- AJAX flavour swap --------------------------------------------------
     Passionfruit, peach and lemon-ginger stay three separate products on
     three separate URLs on purpose (indexed SEO pages; menus, footer, the
     collection rail and the mixed-pack builder all reference these handles —
     see CLAUDE.md). The swatches below stay real <a href> links to those
     URLs so a no-JS visitor gets today's plain navigation unchanged.

     With JS on we intercept the click, fetch the target product's own
     main-product section (`?section_id=main-product` renders just that one
     section), swap the rendered markup in, and let applyFlavour/data-flavour
     above recolour the page from the fresh markup's own attribute. Same
     fetch → DOMParser → swap shape as cart.js's refresh(), just against the
     single-section endpoint instead of the sections= JSON one, because here
     we want a full section (markup changed, not just numbers).

     initProduct() above is already idempotent per-root (it bails out once
     root.dataset.productReady is 'true'), so re-running it against the fresh
     section after a swap binds its listeners exactly once, on the new form —
     the old form (and its listeners) is discarded whole when the old root is
     replaced. Nothing here needs its own re-init guard beyond that. */
  var FLAVOUR_LABELS = {
    passionfruit: 'Passionfruit',
    peach: 'Peach',
    'lemon-ginger': 'Lemon Ginger'
  };

  function productRoot() {
    return document.querySelector('[data-product-root]');
  }

  function handleFromPath(path) {
    var clean = path.split('?')[0].split('#')[0];
    var parts = clean.split('/');
    return parts[parts.length - 1];
  }

  function announceFlavour(handle) {
    var label = FLAVOUR_LABELS[handle] || handle;
    var live = document.querySelector('[data-flavour-announcer]');
    if (!live) {
      live = document.createElement('div');
      live.className = 'sv-visually-hidden';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      live.setAttribute('data-flavour-announcer', '');
      document.body.appendChild(live);
    }
    /* Clear first so back-to-back swaps to a phrase already announced still
       fire — most screen readers only announce on a text change. */
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = 'Now viewing Solid Viibe ' + label + '.';
    }, 50);
  }

  function focusProductHeading(root) {
    var heading = root.querySelector('#product-title');
    if (!heading) return;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  }

  function swapProduct(targetUrl, pushHistory, moveFocus) {
    var root = productRoot();
    if (!root) { window.location.href = targetUrl; return; }
    /* A swap already in flight on this root — ignore a second trigger rather
       than racing two fetches against one element. */
    if (root.getAttribute('aria-busy') === 'true') return;

    root.setAttribute('aria-busy', 'true');

    var sectionUrl = targetUrl.split('#')[0];
    sectionUrl += (sectionUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=main-product';

    fetch(sectionUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Flavour swap request failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot = parsed.querySelector('[data-product-root]');
        if (!freshRoot) throw new Error('Flavour swap markup missing product root');

        /* Replace only the <section data-product-root> itself, not its
           shopify-section wrapper div, so Theme Editor hooks on the wrapper
           survive the swap untouched. */
        root.replaceWith(freshRoot);
        initProduct(freshRoot);

        if (pushHistory && window.history.pushState) {
          window.history.pushState({ svFlavourSwap: true }, '', targetUrl);
        }

        announceFlavour(handleFromPath(targetUrl));
        if (moveFocus) focusProductHeading(freshRoot);
      })
      .catch(function () {
        /* Never leave the customer on a half-swapped page — fall back to a
           real navigation to the flavour they asked for. */
        window.location.href = targetUrl;
      })
      .finally(function () {
        var stillRoot = productRoot();
        if (stillRoot) stillRoot.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.svp-swatches--links a.svp-swatch');
    if (!link) return;
    /* Modified clicks (new tab, new window, download…) and non-primary
       buttons keep behaving like plain links. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (link.target && link.target !== '' && link.target !== '_self') return;
    e.preventDefault();
    if (link.getAttribute('aria-current') === 'page') return;
    swapProduct(link.getAttribute('href'), true, true);
  });

  window.addEventListener('popstate', function () {
    if (!productRoot()) return;
    swapProduct(window.location.pathname + window.location.search, false, true);
  });

  /* --- Gallery ---------------------------------------------------------- */
  function showMedia(id) {
    document.querySelectorAll('[data-gallery-main] [data-media-id]').forEach(function (el) {
      el.hidden = el.dataset.mediaId !== id;
    });
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      var active = btn.dataset.galleryThumb === id;
      btn.setAttribute('aria-current', String(active));
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      showMedia(thumb.dataset.galleryThumb);
    }
    var exactThumb = e.target.closest('.svp-thumb[data-src]');
    if (exactThumb) {
      e.preventDefault();
      var exactRoot = exactThumb.closest('[data-product-root]');
      var main = exactRoot && exactRoot.querySelector('#gallery-main');
      if (main) {
        main.src = exactThumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = exactThumb.dataset.alt || '';
      }
      exactRoot.querySelectorAll('.svp-thumb').forEach(function (button) {
        button.setAttribute('aria-current', String(button === exactThumb));
      });
    }
  });

  /* --- Purchase-type toggle (one-time vs subscribe) ---------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-purchase-type]');
    if (!input) return;
    var subscribing = input.value === 'subscription';
    var planWrap = document.querySelector('[data-selling-plan-wrap]');
    var planSelect = document.querySelector('select[name="selling_plan"]');
    if (planWrap) planWrap.hidden = !subscribing;
    if (planSelect) planSelect.disabled = !subscribing;
    document.querySelectorAll('[data-subscription-note]').forEach(function (el) {
      el.hidden = !subscribing;
    });
  });

  /* --- Quantity steppers (product page + cart page) ---------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyStep, 10);
    input.value = String(Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* ==========================================================================
   Product image zoom
   The main shot is a button (see sections/main-product.liquid); this opens a
   full-screen view of whichever image is currently showing. Built lazily on
   first use so a customer who never zooms pays nothing for it.
   ========================================================================== */
(function () {
  'use strict';

  var overlay = null;
  var lastFocused = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'sv-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Enlarged product image');
    overlay.hidden = true;

    var img = document.createElement('img');
    img.alt = '';
    overlay.appendChild(img);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sv-zoom__close';
    close.setAttribute('aria-label', 'Close enlarged image');
    close.innerHTML = '<svg width="18" height="18" aria-hidden="true" focusable="false"><use href="#i-close"/></svg>';
    overlay.appendChild(close);

    /* Clicking the backdrop closes; clicking the image itself does not, so a
       mis-aimed click on the thing you are looking at is not punished. */
    overlay.addEventListener('click', function (e) {
      if (e.target === img) return;
      hide();
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function show(src, alt) {
    if (!overlay) build();
    var img = overlay.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    lastFocused = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.sv-zoom__close').focus();
  }

  function hide() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  /* Delegated, so it survives the AJAX flavour swap replacing the section. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-zoom-open]');
    if (!trigger) return;
    var shot = trigger.querySelector('img');
    if (!shot) return;
    e.preventDefault();
    show(shot.currentSrc || shot.src, shot.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
})();
